import { Link } from 'react-router-dom';

const footerLinks = [
  { label: 'About', href: '/about' },
  { label: 'Privacy', href: '/privacy' },
  { label: 'Terms', href: '/terms' },
  { label: 'Contact', href: '/contact' }
];

export function Footer() {
  return (
    <footer className="footer">
      <div className="site-shell footer-shell">
        <div className="footer-top">
          <span className="footer-brand">
            <span className="brandmark-name brandmark-name--nav">
              <span className="brandmark-quest">Quest</span>
              <span className="brandmark-flow">Flow</span>
            </span>
          </span>
          <div className="footer-links">
            {footerLinks.map((link) => (
              <Link key={link.label} to={link.href} className="footer-link">
                {link.label}
              </Link>
            ))}
          </div>
        </div>
        <span className="footer-muted footer-copy">(c) 2024 QuestFlow. All rights reserved.</span>
      </div>
    </footer>
  );
}
